<template>
  <CustomCreateDialog
    dialogTitle="ایجاد نقش جدید"
    dialogId="create-new-user-type-dialog"
    :isOkDisabled="isOkButtonDisabled || isModalSubmitButtonDisabled"
    @ok="sendCreateNewUserTypeRequest"
  >
    <BCol cols="12">
      <TextInput
        v-model="newUserTypeDetails.name"
        :formatter="filterOnlyEnglishAlphabet"
        inputId="name"
        inputLabel="نام انگلیسی نقش"
        inputPlaceholder="Accountant"
      ></TextInput>
    </BCol>
    <BCol cols="12">
      <TextInput
        v-model="newUserTypeDetails.title"
        inputId="title"
        inputLabel="نام فارسی نقش"
        inputPlaceholder="حسابدار"
      ></TextInput>
    </BCol>
    <BCol cols="12">
      <TextInput
        v-model="newUserTypeDetails.description"
        inputId="description"
        inputLabel="توضیحات نقش"
        inputPlaceholder="توضیحات..."
      ></TextInput>
    </BCol>
  </CustomCreateDialog>
</template>
<script>
export default {
  emits: ["refetch"],
  data() {
    return {
      newUserTypeDetails: {
        userTypeId: 0,
        name: null,
        title: null,
        description: null,
      },
      englishRegex: /^[A-Za-z\s]+$/,
      isOkButtonDisabled: false,
    };
  },
  methods: {
    filterOnlyEnglishAlphabet(value) {
      if (this.englishRegex.test(value)) {
        return value;
      }
    },
    async sendCreateNewUserTypeRequest() {
      try {
        this.isOkButtonDisabled = true;
        let _this = this;
        let createANewUserType = new CreateANewUserType(_this);
        createANewUserType.setRequestParamDataObj(_this.newUserTypeDetails);
        await createANewUserType.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ایجاد شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "نقش با موفقیت ایجاد شد!",
              },
            });
            _this.newUserTypeDetails = {
              userTypeId: 0,
              name: null,
              title: null,
              description: null,
            };
            _this.$emit("refetch");
            _this.$bvModal.hide("create-new-user-type-dialog");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ایجاد نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.message || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  computed: {
    isModalSubmitButtonDisabled() {
      if (this.newUserTypeDetails.name && this.newUserTypeDetails.title) {
        return false;
      }
      return true;
    },
  },
  components: {
    CustomCreateDialog,
    TextInput,
    BCol,
  },
};
import CustomCreateDialog from "@/views/components/Utils/Dialogs/CustomCreateDialog.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { BCol } from "bootstrap-vue";
import { CreateANewUserType } from "@/libs/Api/UserType";
</script>
